import { useSelector } from 'react-redux';

import { getFundsCurrentTab } from '!views/Market/Funds/redux';
import { getActiveMenuItemSelector } from '»components/Menus';

export function useFundsTab() {
  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const fundsCurrentTab = useSelector(getFundsCurrentTab);

  let currentFundsTab = null;

  if (activeMenuItem === 'MARKET:FUNDS') {
    if (fundsCurrentTab.name === 'fundsManager') {
      currentFundsTab = 'market';
    } else {
      currentFundsTab = 'primary';
    }
  }

  return {
    currentFundsTab,
  };
}
